<template>
  <section class="h-400 mb-12">
    <v-container fluid class="pa-0">
      <v-row>
        <v-col class="pa-0" cols="12" md="6">
          <div
            :class="$vuetify.theme.dark ? 'grey darken-4' : 'bg-light-blue'"
            class="h-400 px-12"
          >
            <v-container class="px-12 fill-height">
              <v-row>
                <v-col cols="12">
                  <h3 class="text-h3 font-weight-bold mb-3">
                    Reward Points explained
                  </h3>
                  <h2 class="text-subtitle-1 font-weight-thin">
                    Reward Points are like a virtual currency, something you can earn and use inside 100ASA
                  </h2>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="hidden-sm-and-down pa-0">
          <div class="hero-image" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'TokensHero'
}
</script>

<style scoped>
.h-400 {
  height: 400px;
}
.bg-light-blue {
  background-color: #e1f5fe;
}
.hero-image {
  background-image: url('/images/tokens/tokens-hero.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  position: relative;
  text-decoration: none;
  width: 100%;
  height: 400px;
}
.hero-image.dark {
  background-image: url('/images/reputation/reputation-hero-dark.jpg');
}
</style>
